import { render } from "./index.vue?vue&type=template&id=5bf9e2d6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=5bf9e2d6&scoped=true&lang=css"
import "@/modules/b2b/views/product-detail/style.scss?vue&type=style&index=1&id=5bf9e2d6&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bf9e2d6"]])

export default __exports__